/* 22natiON Miami Dream — scroll reveal (progressive enhancement only).
   Content is fully visible without JS or with reduced motion. */
(function () {
  document.documentElement.classList.remove('no-js');

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var els = document.querySelectorAll('.md-reveal');

  function showAll() {
    els.forEach(function (el) { el.classList.add('is-inview'); });
  }

  if (prefersReduced.matches || !('IntersectionObserver' in window)) {
    showAll();
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  els.forEach(function (el) { io.observe(el); });

  /* Safety net: never leave content hidden. */
  setTimeout(showAll, 4000);

  prefersReduced.addEventListener('change', function (e) {
    if (e.matches) showAll();
  });
})();
